/*
This component takes a string[] and allows the user to copy it into their clipboard as a newline delimited string.
 */
import { CheckCircle, FileCopy } from '@mui/icons-material';
import { IconButton, Tooltip, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import React, { ReactNode, useState } from 'react';

interface ClipboardProps {
  text: string[];
  displayText?: ReactNode;
}

const Clipboard: React.FC<ClipboardProps> = ({ text, displayText }) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = (_) => {
    navigator.clipboard.writeText(text.join('\n')).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1570);
    });
  };

  return (
    <Box sx={{ position: 'relative' }}>
      {displayText ||
        text.map((content, idx) => {
          return (
            <Typography
              key={`${content}-${idx}`}
              sx={{
                fontFamily: 'monospace',
                border: 'none',
                background: 'none',
                pr: 4,
              }}
            >
              {content}
            </Typography>
          );
        })}
      <Tooltip placement="top" title={copied ? 'Copied' : 'Copy to clipboard'}>
        <IconButton
          onClick={copyToClipboard}
          size="small"
          sx={{
            position: 'absolute',
            top: 1,
            right: 1,
            flex: 1,
            color: copied ? 'green' : 'inherit',
            transition: 'all 0.25s',
            opacity: 0.7,
            '&:hover': {
              opacity: 1,
            },
          }}
        >
          {copied ? (
            <CheckCircle sx={{ fontSize: 16 }} />
          ) : (
            <FileCopy sx={{ fontSize: 16 }} />
          )}
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default Clipboard;
